"use client";

import { TypewriterDemo } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import ServiceSteps from "./ServiceSteps";

const ServiceDetails = () => {
  const tC = useTranslations("common");
  const tH = useTranslations("home");

  return (
    <div
      className={`effect bg-gradient-to-b from-primary to-background bg-cover bg-fixed bg-no-repeat`}
    >
      <div className="gs--page-column pt-15">
        {/* Header Section */}
        <div className="flex flex-col items-center gap-7 text-center">
          <div className="flex items-center gap-2 text-2xl text-white sm:text-3xl lg:text-4xl">
            <span className="text-white">{tC("floorPlan")}</span>
            <span className="text-primary">
              <TypewriterDemo
                strings={[tC("upload"), tC("optimizing"), tC("selling")]}
              />
            </span>
          </div>
          <span className="text-white">{tH("serviceDetails.subtitle")}</span>
        </div>

        {/* Service Steps Section */}
        <div className="bg-secondary mx-5 mt-8 mb-16 flex flex-col items-center justify-center gap-10 rounded-lg px-20 py-24 text-center shadow-lg md:flex-row lg:items-start">
          <ServiceSteps
            step={"01"}
            title={tC("upload")}
            description={tH("serviceDetails.description")}
          />
          <ServiceSteps
            step={"02"}
            title={tC("optimize")}
            description={tH("serviceDetails.description2")}
          />
          <ServiceSteps
            step={"03"}
            title={tC("selling")}
            description={tH("serviceDetails.description3")}
          />
        </div>
      </div>
    </div>
  );
};

export default ServiceDetails;
